import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useQuery } from '@apollo/client'
import { Patient } from '@babylon/consumer-api/types'
import { useAuth0 } from '@auth0/auth0-react'

import { setUserProfile } from '@/redux/userProfile/actions'
import { useUserId } from '@/redux/userProfile/selectors'
import UserQuery from '@/queries/Patient'
import { filterUserObject } from '@/utils'
import getUserFromToken from '@/utils/getUserFromToken'
import { authTokenStorageKey } from '@/constants'

const useCurrentUser = () => {
  const dispatch = useDispatch()
  const userId = useUserId()
  const { isLoading } = useAuth0()
  const token = sessionStorage.getItem(authTokenStorageKey)
  let tokenId

  if (token) {
    tokenId = getUserFromToken(token)
  }

  // This is the auth0 returns the uuid and cannot be changed
  const id = tokenId || userId

  const { data: userData, loading: userLoading } = useQuery<{
    patient: Patient
  }>(UserQuery, {
    fetchPolicy: 'network-only',
    variables: { id },
    skip: isLoading || !id,
  })

  useEffect(() => {
    if (!userLoading && userData) {
      const patient = filterUserObject(userData?.patient)
      dispatch(setUserProfile(patient))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData])

  return {
    userData,
    userLoading: isLoading || userLoading,
  }
}

export default useCurrentUser
